import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import Award from "./components/Award";
import Architecture from "./components/Architecture";
import Amenities from "./components/Amenities";
import Specifications from "./components/Specifications";
import Gallery from "./components/Gallery";
import Rates from "./components/Rates";
import Location from "./components/Location";
import Exclusivity from "./components/Exclusivity";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function Home() {
  return (
    <div className="bg-[#F5F0E8] text-[#2A2A28]">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Award />
        <Architecture />
        <Specifications />
        <Gallery />
        <Amenities />
        <Rates />
        <Location />
        <Exclusivity />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
